import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import $ from 'jquery';

// TODO: module animation timing based on distance to top so scrolling is never super fast or super slow
var BackToTop = /*#__PURE__*/function () {
  function BackToTop() {
    var _this = this;
    _classCallCheck(this, BackToTop);
    this.selector = ".component-back-to-top";
    this.$el = $(this.selector);
    if (!this.$el.length) return false;
    this.$el.on('click', function () {
      return _this.scrollToTop();
    });
  }
  _createClass(BackToTop, [{
    key: "scrollToTop",
    value: function scrollToTop() {
      $('html, body').animate({
        scrollTop: 0
      }, 500);
    }
  }]);
  return BackToTop;
}();
new BackToTop();